<div class="container text-muted">
    <div class="row">
        <!-- Documents -->
        <div class="col-xs-4 border-right p-0 text-muted">
            <app-documents-tree *ngIf="!loadingFolders"
                [folders]="folders"
                customStyle="height: 250px"
                [isJobMatchFolders]="false"
                [availableDocumentsInFolders]="allAvailableDocuments"
                (onAddFolder)="addDocumentFolder($event.parentFolder)"
                (onEditFolder)="editDocumentFolder($event.folder)"
                (onDeleteFolder)="deleteDocumentFolder($event.folder)"
                (onMoveFolder)="moveDocumentFolder($event.folder)"
                (onSelectFolder)="onFolderSelect($event.selectedFolder)">
            </app-documents-tree>
            <app-documents-tree *ngIf="!loadingFolders"
                [folders]="candidateJobMatchFolders"
                [isJobMatchFolders]="true"
                customStyle="height: 250px"
                (onSelectFolder)="onFolderSelect($event.selectedFolder)">
            </app-documents-tree>
            <!-- Folder tree skeleton -->
            <div *ngIf="loadingFolders" class="skeleton-container p-2" style="height:530px">
                <div class="d-flex align-items-center mb-4" *ngFor="let placeholderFolder of skeletonPlaceholderFolders">
                    <div class="skeleton-img skeleton-loading mr-2" style="width:16px;height:16px;border-radius:3px;"></div>
                    <div class="skeleton-heading skeleton-loading" [ngClass]="placeholderFolder"></div>
                </div>
            </div>
        </div>
        <div class="col-xs-8 px-4 py-2" *ngIf="loadingFolders">
            <div class="skeleton-heading skeleton-loading mb-3" style="width: 30%;"></div>
            <div class="skeleton-paragraph skeleton-loading mb-3" style="width: 50%;"></div>
            <div class="d-flex align-items-center mb-4" *ngFor="let row of [0, 1, 2, 3]">
                <div class="skeleton-img skeleton-loading mr-2" style="width:16px;height:16px;border-radius:3px;"></div>
                <div class="skeleton-heading skeleton-loading" style="width: 60%;"></div>
            </div>
        </div>
        <!-- Document details -->
        <div class="col-xs-8 px-4 py-2 cursor-pointer" *ngIf="selectedFolder && !loadingFolders">
            <div class="d-flex justify-content-between align-items-center border-bottom mb-3 pb-3">
                <span style="font-weight:bold;">
                    {{selectedFolder.name}} <br>
                    <small class="text-muted" style="font-weight: normal;">{{selectedFolder.description}}</small>
                </span>
                <button class="btn btn-primary" (click)="onAddDocument()" *ngIf="!selectedFolder.isJobMatchFolders && selectedFolder.id != 'sharedFolder'">
                    <i class="fas fa-plus"></i>    Document
                </button>
            </div>

            <div class="documents">
                <div *ngIf="selectedFolder.documents.length==0"
                    class="d-flex text-muted justify-content-center align-items-center mt-5">
                    <p>No documents added.</p>
                </div>
                <span *ngIf="selectedFolder.documents.length>0"
                    class="mt-3 text-muted d-block mb-3"
                    style="font-size:12px; font-weight:bold;">FILES</span>
                <div class="folders-container">
                    <div class="position-relative d-flex flex-column rounded border p-4 folder-document"
                        (mouseover)="file.showActions=true"
                        (mouseleave)="file.showActions=false"
                        [ngClass]="{'bg-purple': file.shared, 'candidate-document-selected-bg': file.selected, 'folder-active' : file.isDocumentSelected}"
                        *ngFor="let file of selectedFolder.documents"
                        (dblclick)="viewDocumentFIle(file)">
                        <div class="position-absolute" style="left:10px; top:4px">
                            <small tooltip="Document version" container="body" [adaptivePosition]="false">V{{file.version}}</small>
                        </div>
                        <div [hidden]="!file.showActions" class="position-absolute d-flex" style="top:5px;right:7px;">
                            <a class="px-2" (click)="viewDocumentFIle(file)" tooltip="View" container="body" [adaptivePosition]="false">
                                <i class="fas fa-eye text-muted"></i>
                            </a>
                            <a class="px-2" (click)="mailDocument(file)" tooltip="Email" container="body" [adaptivePosition]="false">
                                <i class="fas fa-envelope text-muted"></i>
                            </a>
                            <a class="px-2" [href]="file.link" download tooltip="Download" container="body" [adaptivePosition]="false">
                                <i class="fas fa-download text-muted"></i>
                            </a>
                            <div [hidden]="!file.editable" class="dropdown px-2" dropdown>
                                <i class="fas fa-ellipsis-v text-muted"
                                    data-toggle="dropdown"
                                    dropdownToggle
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                </i>
                                <ul *dropdownMenu role="menu" class="dropdown-menu dropdown-menu-right document-actions">
                                    <li role="menuitems">
                                        <a class="document-action" href="javascript:void(0)" (click)="onAddDocument(file, 'edit')">
                                            Edit Note
                                        </a>
                                    </li>
                                    <li role="menuitems">
                                        <a class="document-action" href="javascript:void(0)" (click)="onAddDocument(file)">
                                            Upload New Version
                                        </a>
                                    </li>
                                    <li role="menuitems" *ngIf="isSharedDocumentActionAvailable">
                                        <a class="document-action" href="javascript:void(0)" (click)="onAddDocument(file, 'share')">
                                            Share/Unshare
                                        </a>
                                    </li>
                                    <li role="menuitems">
                                        <a class="document-action" href="javascript:void(0)" (click)="moveDocument(file)">
                                            Move
                                        </a>
                                    </li>
                                    <li role="menuitems">
                                        <a class="document-action" href="javascript:void(0)" (click)="deleteDocument(file)">
                                            Delete
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="border-bottom d-flex justify-content-center align-items-center mt-3">
                            <img
                                class="pb-3 pt-2"
                                [src]="file.icon"
                                alt=""
                                style="height:80px">
                            <i *ngIf="file.note && file.note.length>0" class="fas fa-clipboard text-primary" tooltip="{{file.note}}"></i>
                        </div>
                        <div>
                            <strong class="p-2 d-block text-overflow-ellipsis" tooltip="{{file.displayFileName || file.fileName}}" container="body" [adaptivePosition]="false" style="max-width: 160px;">{{file.displayFileName || file.fileName}}</strong>
                            <small class="pull-left pt-2 text-muted" *ngIf="file.shared && file.sharedTo.length>0">
                                {{file.sharedToText}}
                                <i class="fas fa-share-alt text-primary"
                                    [popover]="clientsPopover"
                                    popoverTitle="Shared with"
                                    triggers="mouseenter">
                                </i>
                                <ng-template #clientsPopover>
                                    <div *ngFor="let client of file.sharedTo">
                                        <span class="d-block">{{client.shortName}}</span>
                                    </div>
                                </ng-template>
                            </small>
                            <small *ngIf="file.uploadedDate" class="pull-right pt-2 text-muted" tooltip="Uploaded On" container="body" [adaptivePosition]="false">
                                {{file.uploadedDate | fourDotFiveDateFormatPipe}}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xs-8 px-4 py-2" *ngIf="!selectedFolder && !loadingFolders">
            <div class="d-flex justify-content-center align-items-center text-muted">
                <h4>
                    No folders selected
                </h4>
            </div>
        </div>
    </div>
</div>
